<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header data-background-color="blue">
            <h4 class="title">Bandeja de Notificaciones</h4>
            <p class="category">Alertas de cambios en tus evidencias y mensajes de revisión.</p>
          </md-card-header>
          <md-card-content>
            <div v-if="loading" class="loading-state">Cargando notificaciones...</div>
            <div v-else-if="!notifications.length" class="empty-state">
              <i class="fas fa-bell-slash"></i>
              <p>No tienes notificaciones pendientes.</p>
            </div>
            <div v-else class="notifications-list">
              <div 
                v-for="notif in notifications" 
                :key="notif.id" 
                class="notification-item" 
                :class="{ 'unread': !notif.read }"
                @click="handleNotificationClick(notif)"
              >
                <div class="notif-icon">
                  <i class="fas" :class="notif.read ? 'fa-envelope-open' : 'fa-envelope'"></i>
                </div>
                <div class="notif-body">
                  <div class="notif-header">
                    <span class="sender">{{ notif.senderName }}</span>
                    <span class="date">{{ formatDate(notif.createdAt) }}</span>
                  </div>
                  <p class="message" :class="{ 'sentencing-text': notif.type === 'sentencing' }">{{ notif.message }}</p>
                  <div v-if="notif.pdfUrl" class="notif-attachment">
                    <a :href="notif.pdfUrl" target="_blank" class="pdf-link" @click.stop>
                      <i class="fas fa-file-pdf"></i>
                      Ver Acta de Acusación (PDF)
                    </a>
                  </div>
                </div>
                <div class="notif-actions" @click.stop>
                   <md-button class="md-icon-button md-simple md-primary" @click="markAsRead(notif.id)" v-if="!notif.read">
                     <md-icon>done</md-icon>
                   </md-button>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { collection, query, where, getDocs, updateDoc, doc, orderBy } from "firebase/firestore";
import { db } from "@/fb";

export default {
  name: "NotificationsPage",
  data() {
    return {
      loading: false,
      notifications: []
    };
  },
  created() {
    this.loadNotifications();
  },
  methods: {
    async loadNotifications() {
      this.loading = true;
      try {
        const myId = this.$delegateStore?.state?.delegateData?.delegation?.id;
        if (!myId) return;
        const q = query(
          collection(db, "notifications"),
          where("recipientId", "==", myId),
          orderBy("createdAt", "desc")
        );

        const snapshot = await getDocs(q);
        this.notifications = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      } catch (e) {
        // Error silenciado para producción
      } finally {
        this.loading = false;
      }
    },
    async markAsRead(id) {
      try {
        await updateDoc(doc(db, "notifications", id), { read: true });
        const notif = this.notifications.find(n => n.id === id);
        if (notif) notif.read = true;
      } catch (e) {
        // Error silenciado para producción
      }
    },
    handleNotificationClick(notif) {
      if (!notif.read) this.markAsRead(notif.id);
      
      if (notif.type === 'sentencing') {
        if (notif.pdfUrl) window.open(notif.pdfUrl, '_blank');
        return;
      }

      const isPresident = this.$delegateStore.state.authContext?.role === "president";
      this.$router.push({
        path: isPresident ? "/evidence-review/president" : "/evidence-review",
        query: { evidenceId: notif.evidenceId }
      });
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString();
    }
  }
};
</script>

<style scoped>
.loading-state, .empty-state {
  padding: 40px;
  text-align: center;
  color: #64748b;
}
.empty-state i { font-size: 32px; margin-bottom: 10px; }
.notifications-list { display: flex; flex-direction: column; }
.notification-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: background 0.2s;
}
.notification-item:hover { background: #f8fafc; }
.notification-item.unread { background: #f0f9ff; border-left: 4px solid #23233a; }
.notif-icon { width: 40px; color: #23233a; font-size: 18px; }
.notif-body { flex: 1; }
.notif-header { display: flex; justify-content: space-between; margin-bottom: 4px; }
.sender { font-weight: 700; font-size: 13px; color: #1e293b; }
.date { font-size: 11px; color: #94a3b8; }
.message { margin: 0; font-size: 13px; color: #475569; }

.sentencing-text {
  white-space: pre-wrap;
  font-style: italic;
  border-left: 2px solid #23233a;
  padding: 8px 0 8px 12px;
  background: #f8fafc;
  margin: 4px 0;
}
.notif-attachment { margin-top: 10px; }
.pdf-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #b91c1c;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
}
.pdf-link:hover { text-decoration: underline; }
</style>